import type { EleicaoSnapshot } from '@/shared/types';

const ORDEM_TIPOS = ['presidente', 'governador', 'senador'];

// Nome por extenso só das UFs acompanhadas; sigla desconhecida cai na própria sigla.
const NOME_UF: Record<string, string> = { go: 'Goiás' };

function tipoDoCargo(chave: string): string {
  return chave.split('-')[0];
}

/** Presidente, depois Governador, depois Senador; empate pela chave (estável entre UFs). */
export function ordenarSnapshots(lista: EleicaoSnapshot[]): EleicaoSnapshot[] {
  const posicao = (s: EleicaoSnapshot) => {
    const i = ORDEM_TIPOS.indexOf(tipoDoCargo(s.cargo ?? 'presidente'));
    return i === -1 ? ORDEM_TIPOS.length : i;
  };
  return [...lista].sort((a, b) => posicao(a) - posicao(b) || (a.cargo ?? '').localeCompare(b.cargo ?? ''));
}

/** Título legível do cargo: "Presidente", "Governador de Goiás", "Senador de Goiás". */
export function tituloCargo(chave: string | undefined): string {
  const cargo = chave ?? 'presidente';
  const [tipo, uf] = cargo.split('-');
  if (tipo === 'presidente') return 'Presidente';
  const nome = tipo === 'governador' ? 'Governador' : tipo === 'senador' ? 'Senador' : tipo;
  if (!uf) return nome;
  const nomeExtenso = NOME_UF[uf.toLowerCase()];
  return nomeExtenso ? `${nome} de ${nomeExtenso}` : `${nome} (${uf.toUpperCase()})`;
}
